import RentCard from "./RentCard";

export default function RentWarehouse() {
  return (
    <section className="mct-section items-section lucky-hours-section d-flex justify-content-center">
      <RentCard />
    </section>
  );
}
